import moment from "moment";
import numberToWord from "number-to-words";
import { useRef } from "react";
import InterFont from "../../../fonts/Inter.ttf";
import { useNotification } from "../../../hooks/useNotification";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import jsPDF from "jspdf";
import { useHistory } from "react-router-dom";

const PaySlipTable = ({
  paymentDate,
  userData,
  payslipFileRef,
  payslipData,
  currentSalaryData,
}) => {
  const history = useHistory(null);
  const token = localStorage.getItem("token");
  const handleNotificationCall = useNotification();
  const decode = jwtDecode(token);

  const containerStyle = {
    fontFamily: "Arial, sans-serif",
    margin: "20px auto",
    width: "90%",
    minWidth: "800px",
    // minHeight: "1000px",
    maxWidth: "800px",
  };

  const headerStyle = {
    textAlign: "center",
    fontWeight: "bold",
    padding: "10px 0",
    fontSize: "18px",
    borderBottom: "1px solid #000",
  };

  const sectionStyle = {
    padding: "8px",
    borderBottom: "1px solid #000",
  };

  const tableStyle = {
    width: "100%",
    marginTop: "10px",
    border: "1px solid #000",
    borderCollapse: "collapse",
  };

  const tableStyleWithoutBorder = {
    width: "100%",
    marginTop: "10px",
    border: "none",
    borderCollapse: "collapse",
  };

  const thTdStyle = {
    border: "1px solid #000",
    padding: "6px 8px",
    textAlign: "left",
  };

  const thTdStyleWithoutBorderRight = {
    border: "none",
    padding: "6px 8px",
    textAlign: "right",
  };

  const thTdStyleWithoutBorder = {
    border: "none",
    padding: "6px 8px",
    textAlign: "left",
  };

  const earningsTableBorder = {
    border: "none",
    padding: "6px 0px 6px 8px",
    textAlign: "left",
    verticalAlign: "baseline",
  };

  const thTdStyleleftBorderNone = {
    border: "1px solid #000",
    padding: "6px 8px",
    textAlign: "left",
    borderLeft: "none",
  };

  const deductionTableBorder = {
    border: "none",
    padding: "6px 8px 6px 0px",
    textAlign: "left",
    verticalAlign: "baseline",
  };

  const thTdStyleFooter = {
    border: "none",
    padding: "6px 8px",
    textAlign: "center",
    marginTop: "10px",
  };

  const totalStyle = { fontWeight: "bold" };

  const totalDays = moment(paymentDate, "YYYY-M").daysInMonth();

  function formatToINR(amount) {
    // return new Intl.NumberFormat("en-IN", {
    //   currency: "INR",
    // }).format(Math.round(amount).toFied(x2));
    const currecyData = parseFloat(Math.round(amount)).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // const data = Number(parseFloat(Math.round(amount)).toFixed(2)).toLocaleString();
    return currecyData;
  }

  const earnings = [
    {
      name: "BASIC",
      full: payslipData.masterValues.basicSalary,
      actual: payslipData?.grossValues.basicSalary,
    },
    {
      name: "HRA",
      full: payslipData.masterValues.hra,
      actual: payslipData.grossValues.hra,
    },
    {
      name: "CONVEYANCE",
      full: payslipData.masterValues.conveyance,
      actual: payslipData.grossValues.conveyance,
    },
    {
      name: "TELEPHONE ALLOWANCE",
      full: payslipData.masterValues.telephoneAllowance,
      actual: payslipData.grossValues.telephoneAllowance,
    },
    {
      name: "MEDICAL ALLOWANCE",
      full: payslipData.masterValues.medicalAllowance,
      actual: payslipData.grossValues.medicalAllowance,
    },
    {
      name: "SPECIAL ALLOWANCE",
      full: payslipData.masterValues.specialAllowance,
      actual: payslipData.grossValues.specialAllowance,
    },
    {
      name: "CONSULTANT",
      full: payslipData.masterValues.consultant,
      actual: payslipData.grossValues.consultant,
    },
    {
      name: "STATUTORY BONUS",
      full: payslipData.masterValues.statutoryBonus,
      actual: payslipData.grossValues.statutoryBonus,
    },
    {
      name: "STATUTORY APPLICABILITY",
      full: payslipData.masterValues.statutoryApplicability,
      actual: payslipData.grossValues.statutoryApplicability,
    },
    {
      name: "SHIFT ALLOWANCE",
      full: payslipData.masterValues.shiftAllowance,
      actual: payslipData.grossValues.shiftAllowance,
    },
    {
      name: "BASIC ARREAR",
      full: 0,
      actual: payslipData.earningValues.basicAllowanceArrears,
    },
    {
      name: "HRA ARREAR",
      full: 0,
      actual: payslipData.earningValues.hraArrears,
    },
    {
      name: "TELEPHONE ALLOWANCE ARREAR",
      full: 0,
      actual: payslipData.earningValues.telephoneAllowanceArrear,
    },
    {
      name: "CONVEYANCE ARREAR",
      full: 0,
      actual: payslipData.earningValues.conveyanceArrears,
    },
    {
      name: "MEDICAL ALLOWANCE ARREAR",
      full: 0,
      actual: payslipData.earningValues.medicalAllowanceArrear,
    },
    {
      name: "OTHER ALLOWANCE ARREAR",
      full: 0,
      actual: payslipData.earningValues.otherAllowanceArrear,
    },
    {
      name: "ARREARS",
      full: 0,
      actual: payslipData.earningValues.arrears,
    },
    {
      name: "CONSULTANT ARREARS",
      full: 0,
      actual: payslipData.earningValues.consultantArrears,
    },
    {
      name: "STATUTORY BONUS ARREARS",
      full: 0,
      actual: payslipData.earningValues.statutoryBonusArrears,
    },
    {
      name: "SHIFT ALLOWANCE ARREAR",
      full: 0,
      actual: payslipData.earningValues.shiftAllowanceArrears,
    },
    {
      name: "BONUS",
      full: 0,
      actual: payslipData.earningValues.bonus,
    },
    {
      name: "INCENTIVES",
      full: 0,
      actual: payslipData.earningValues.incentives,
    },
    {
      name: "OTHER ALLOWANCE",
      full: payslipData.masterValues.otherAllowance,
      actual: payslipData.grossValues.otherAllowance,
    },
    {
      name: "OTHER EARNINGS",
      full: 0,
      actual: payslipData.earningValues.otherEarnings,
    },
    {
      name: "REFUND FOR LAST MONTH DEDUCTION",
      full: 0,
      actual: payslipData.earningValues.refundForLastMonthDeduction,
    },

    {
      name: "MONTHLY PERFORMANCE ALLOWANCE",
      full: 0,
      actual: payslipData.earningValues.monthlyPerformanceArrears,
    },

    {
      name: "ROLE PERFORMANCE BONUS",
      full: 0,
      actual: payslipData.earningValues.rolePerformanceBonus,
    },
    {
      name: "Total Gross Salary ",
      full: payslipData.totalMaster,
      actual: payslipData.totalGross + payslipData.totalEarnings,
    },
  ];

  const deductions = [
    { name: "PF", actual: payslipData.deductionValues.pf },
    { name: "ESI", actual: payslipData.deductionValues.esi },
    { name: "INCOME TAX", actual: payslipData.deductionValues.incomeTax },
    { name: "PROF TAX", actual: payslipData.deductionValues.professionalTax },
    { name: "LOAN", actual: payslipData.deductionValues.loan },
    {
      name: "LABOUR WELFARE FUND",
      actual: payslipData.deductionValues.labourWelfareFund,
    },
    {
      name: "OTHER DEDUCTION",
      actual: payslipData.deductionValues.otherDeduction,
    },
    {
      name: "NOTICE PERIOD DEDUCTION",
      actual: payslipData.deductionValues.noticePeriodDeduction,
    },
    {
      name: "SPECIAL PURPOSE DEDUCTION",
      actual: payslipData.deductionValues.specialPurposeDeduction,
    },
    {
      name: "STANDARD DEDUCTION",
      actual: payslipData.deductionValues.standardDeduction,
    },
    { name: "Total Deductions", actual: payslipData.totalDeduction },
  ];

  const filterFields = (fields) =>
    fields.filter((field) => field.full !== 0 || field.actual !== 0);

  const filterDeductionFields = (fields) =>
    fields.filter((field) => field.actual !== 0);

  const totalEarningAmount = filterFields(earnings)[
    filterFields(earnings).length - 1
  ];
  const allEarningsData = filterFields(earnings).slice(0, -1); // All elements except the last one

  const totalDeductionAmount = filterDeductionFields(deductions)[
    filterDeductionFields(deductions).length - 1
  ];
  const allDeductionsData = filterDeductionFields(deductions).slice(0, -1); // All elements except the last one

  return (
    <div style={containerStyle} ref={payslipFileRef}>
      {/* Payslip Header */}

      <table style={tableStyle}>
        <tbody>
          <tr>
            <td colSpan={2}>
              <div style={headerStyle}>
                Payslip for the Month of{" "}
                {moment(paymentDate).format("MMMM YYYY")}
              </div>
            </td>
          </tr>
          <tr>
            <td style={thTdStyleWithoutBorder}>
              <table style={tableStyleWithoutBorder}>
                <tbody>
                  <tr>
                    <td>Name:</td>
                    <td>
                      <strong>
                        {userData.employee
                          ? userData.employee?.firstName
                          : userData.recruiter
                          ? userData.recruiter.firstName
                          : "-"}{" "}
                        {userData.employee
                          ? userData.employee?.lastName
                          : userData.recruiter
                          ? userData.recruiter.lastName
                          : "-"}
                      </strong>{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>Date of Joining</td>
                    <td>
                      {userData.employee
                        ? moment(userData.employee?.joinningDate).format(
                            "DD-MM-YYYY",
                          )
                        : userData.recruiter
                        ? moment(userData.recruiter?.joinningDate).format(
                            "DD-MM-YYYY",
                          )
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td>Designation</td>
                    <td>
                      {(userData.designation && userData.designation.title) ||
                        "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>Department</td>
                    <td>
                      {(userData.designation &&
                        userData.designation.department?.title) ||
                        "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>Location</td>
                    <td>
                      {userData.employee
                        ? userData.employee?.companyBranchName
                        : userData.recruiter
                        ? userData.recruiter.companyBranchName
                        : "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>Grade</td>
                    <td>
                      {userData.salary_detail
                        ? userData.salary_detail?.grade
                        : "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>Effective Work Days</td>
                    <td>{payslipData?.effective_work_days}</td>
                  </tr>
                  <tr>
                    <td>Days in Month</td>
                    <td>{totalDays}</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td style={thTdStyleWithoutBorder}>
              <table style={tableStyleWithoutBorder}>
                <tbody>
                  <tr>
                    <td>Bank Name:</td>
                    <td>
                      {userData?.salary_detail?.bankName || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>Bank Account No:</td>
                    <td>
                      {userData?.salary_detail?.bankAccountNumber ||
                        "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>Bank IFSC Code:</td>
                    <td>
                      {userData.salary_detail?.bankIfscCode || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>PF No:</td>
                    <td>
                      {userData.salary_detail?.pfNumber || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>UAN:</td>
                    <td>
                      {userData.salary_detail?.uanNumber || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>ESI No:</td>
                    <td>
                      {userData.salary_detail?.esiNumber || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>PAN No:</td>
                    <td>
                      {userData.salary_detail?.panNumber || "Not Provided"}
                    </td>
                  </tr>
                  <tr>
                    <td>LOP:</td>
                    <td>{payslipData?.lopCount} Days</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td style={earningsTableBorder}>
              {/* Earnings and Deductions */}
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thTdStyle}>Earnings</th>
                    <th style={thTdStyle}>Full</th>
                    <th style={thTdStyle}>Actual</th>
                  </tr>
                </thead>
                <tbody>
                  {allEarningsData.map((field, index) => (
                    <tr key={index}>
                      <td style={{ ...thTdStyle, fontWeight: 400 }}>
                        {field.name}
                      </td>
                      <td style={{ ...thTdStyle, fontWeight: 400 }}>
                        {field.full === 0 ? "" : formatToINR(field.full)}
                      </td>
                      <td
                        style={{
                          ...thTdStyle,
                          fontWeight:
                            index === filterDeductionFields(earnings).length - 1
                              ? 600
                              : 400,
                        }}
                      >
                        {formatToINR(field.actual)}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td style={{ ...thTdStyle, fontWeight: 600 }}>
                      {totalEarningAmount.name}
                    </td>
                    <td style={{ ...thTdStyle, fontWeight: 600 }}>
                      {formatToINR(totalEarningAmount.full)}
                    </td>
                    <td style={{ ...thTdStyle, fontWeight: 600 }}>
                      {formatToINR(totalEarningAmount.actual)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td style={deductionTableBorder}>
              <table style={tableStyleWithoutBorder}>
                <thead>
                  <tr>
                    <th style={thTdStyleleftBorderNone}>Deductions</th>
                    <th style={thTdStyle}>Actual</th>
                  </tr>
                </thead>
                <tbody>
                  {allDeductionsData.map((field, index) => (
                    <tr key={index}>
                      {/* Leave earnings columns blank for deduction rows */}
                      <td
                        style={{ ...thTdStyleleftBorderNone, fontWeight: 400 }}
                      >
                        {field.name}
                      </td>
                      <td
                        style={{ ...thTdStyleleftBorderNone, fontWeight: 400 }}
                      >
                        {formatToINR(field.actual)}
                      </td>
                    </tr>
                  ))}
                  {Array.from({
                    length:
                      filterDeductionFields(earnings)?.length -
                      filterDeductionFields(deductions)?.length,
                  }).map((item, index) => (
                    <tr key={index}>
                      <td style={thTdStyleleftBorderNone}>
                        <br />
                      </td>
                      <td style={thTdStyle}>
                        <br />
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td style={{ ...thTdStyleleftBorderNone, fontWeight: 600 }}>
                      {totalDeductionAmount.name}
                    </td>
                    <td style={{ ...thTdStyle, fontWeight: 600 }}>
                      {formatToINR(totalDeductionAmount.actual)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td colSpan={2} style={thTdStyleFooter}>
              <p style={{ fontWeight: "bold", fontSize: "16px" }}>
                Net Pay for the month (Total Earnings - Total Deductions):{" "}
                <span style={{ fontSize: "18px", color: "green" }}>
                  {formatToINR(payslipData.netValue)}
                </span>
              </p>
              <p
                style={{
                  fontStyle: "italic",
                  color: "#555",
                  textDecoration: "capitalize",
                }}
              >
                (Rupees {numberToWord.toWords(payslipData.netValue)})
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ textAlign: "center", fontSize: "12px", color: "#666" }}>
        <p>
          This is a system-generated payslip and does not require signature.
        </p>
      </div>
    </div>
  );
};

export default PaySlipTable;
